
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { updateDraftDiscount, updateRecordsDiscount, getSuppliersList } from "@/api/inquiry";
import {
  updatePackingAndAccessories,
  createPackingAndAccessories,
  getPackingAndAccessories,
  getPackingAndAccessoriesType,
  getProformaInvoiceTypes
} from "@/api/proforma";
import { deepClone } from "@/utils/deepClone";

@Component({
  name: "ModifyDiscounts"
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: false }) private isEdit: boolean;
  @Prop({ default: {} }) private selectedItem: {} | any;
  @Prop({ default: "" }) private id: "";
  @Prop({ default: "包装与配件" }) private title: "";


  @Watch("show", { immediate: true })
  private async watchItem() {
    await this.init();
    if (this.show && this.selectedItem.id) {
      await this.getPackingAndAccessories();
    } else {
      Object.keys(this.form).forEach((key: string) => {
        this.form[key] = null;
      });
    }
  }

  private form = {
    "piInfoType": null,
    "typeValue": null,
    "supplierId": null,
    "hqTransactionNumber": null,
    "quantity": null,
    "purchaseAmount": null,
    "saleAmount": null,
    "batchNumber": null,
    "shippingRemark": null,
    "purchaseOrderGroup": null,
    "saleUnitPrice": null,
    "purchaseUnitPrice": null
  };
  private newSelectedRows: any[] = [];
  private typeList: any[] = [];

  // @Watch("selectedList", { immediate: true })
  // private async watchData() {
  //   this.newSelectedRows = deepClone(this.selectedList);
  // }
  private list = [
    {
      label: "选择类型",
      prop: "typeValue",
      key: "typeValue",
      type: "cascader",
      placeholder: "请选择",
      clearable: true,
      propsData: { label: "name", checkStrictly: false, value: "name", children: "types" },
      options: [],
      rules: {
        required: true,
        message: "请选择类型",
        trigger: "blur"
      }

    },
    {
      label: "供应商",
      prop: "supplierId",
      key: "supplierId",
      type: "select",
      value: "",
      placeholder: "请选择供应商",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      labelKey: "abbreviation",
      valueKey: "id",
      rules: {
        required: true,
        message: "请选择供应商",
        trigger: "change"
      }
    },
    {
      label: "HQ交易号码",
      prop: "hqTransactionNumber",
      key: "hqTransactionNumber",
      type: "input",
      placeholder: "请输入HQ交易号码",
      clearable: true,
      maxlength: 10
    },
    {
      label: "下单数量",
      prop: "quantity",
      key: "quantity",
      type: "inputNumber",
      placeholder: "请输入下单数量",
      clearable: true,
      maxlength: 10,
      rules: {
        required: true,
        message: "请输入下单数量",
        trigger: "blur"
      }
    },
    {
      label: "采购费用",
      prop: "purchaseAmount",
      key: "purchaseAmount",
      type: "inputNumber",
      placeholder: "请输入采购费用",
      clearable: true,
      maxlength: 10,
      rules: {
        required: true,
        message: "请输入采购费用",
        trigger: "blur"
      }
    },
    {
      label: "销售金额",
      prop: "saleAmount",
      key: "saleAmount",
      type: "inputNumber",
      placeholder: "请输入销售金额",
      clearable: true,
      disabled: false,
      maxlength: 10
    },

    {
      label: "生产批次号",
      prop: "batchNumber",
      key: "batchNumber",
      type: "input",
      placeholder: "请输入生产批次号",
      clearable: true,
      maxlength: 10
    },
    {
      label: "出货备注",
      prop: "shippingRemark",
      key: "shippingRemark",
      type: "textarea",
      placeholder: "请输入出货备注",
      clearable: true
    },
    {
      label: "订单拆分",
      prop: "purchaseOrderGroup",
      key: "purchaseOrderGroup",
      type: "input",
      placeholder: "请输入订单拆分",
      clearable: true,
      maxlength: 10
    }
  ] as any;

  private init() {
    this.getPackingAndAccessoriesType();
    this.getProformaInvoiceTypes();
  }

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private async getPackingAndAccessories() {
    const res: any = await getPackingAndAccessories(this.selectedItem.id);
    Object.keys(this.form).forEach((key: string) => {
      this.form[key] = res[key];
    });
    if (res.supplierAbbr) {
      await this.getSuppliersList(res.supplierAbbr);
    }
    if (res.type) {
      const type = res.type.replace(/'/g, "\"");
      this.form.typeValue = JSON.parse(type);
    }
    this.formUpdate(this.form);

  }

  private formUpdate(obj) {
    let index = this.list.findIndex((item: any) => item.key === "saleAmount");
    let piInfoType = this.typeList.find((item: any) => item.desc === obj.typeValue[0]).name;
    if (piInfoType === "PACKING") {
      this.form.saleAmount = null;
      this.list[index].disabled = true;
    } else {
      this.list[index].disabled = false;
    }
  }

  private async getPackingAndAccessoriesType() {
    const res = await getPackingAndAccessoriesType();
    this.list[0].options = res;
  }

  private async getProformaInvoiceTypes() {
    const res: any = await getProformaInvoiceTypes();
    this.typeList = res;
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.list[1].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }


  private async submitForm(): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            await this.savePackingAndAccessories();
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }

  private async savePackingAndAccessories() {
    let { typeValue } = this.form;
    let piInfoType = this.typeList.find((item: any) => item.desc === this.form.typeValue[0]).name;
    if (typeValue && typeValue.length > 2) {
      typeValue.shift();
    }
    Object.keys(this.form).forEach((key: string) => {
      if (this.form[key] === 0){
        return;
      }
      this.form[key] = this.form[key] || null;
    });
    if (piInfoType === "PACKING") {
      this.form.saleAmount = null;
    }
    let params = {
      ...this.form,
      piInfoType,
      typeValue: typeValue.join("-")
    };
    try {
      this.selectedItem.id ? await updatePackingAndAccessories(this.selectedItem.id, params) : await createPackingAndAccessories(this.id, params);
      this.$notify({
        title: "提示",
        message: "成功",
        type: "success",
        duration: 2000
      });
      this.close();
      this.$emit("success", false);
    } catch (e) {
      console.log(e);
    }
  }
}
